let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9XHI6")).then(() => parcelRequire('jSci2'));